export const WEB_APP_VERSION = process.env.REACT_APP_APP_VERSION || "1.0.0";

export async function getInstalledVersion() {
  try {
    const cap = await import("@capacitor/core");
    if (cap.Capacitor?.isNativePlatform?.()) {
      const { App } = await import("@capacitor/app");
      const info = await App.getInfo();
      if (info?.version) return String(info.version);
    }
  } catch {
    /* web o plugin assente */
  }
  return WEB_APP_VERSION;
}

export async function openApkDownload(url) {
  const { reachableApkUrl } = await import("@/lib/api");
  const safe = reachableApkUrl(url);
  if (!safe) return;
  try {
    const cap = await import("@capacitor/core");
    if (cap.Capacitor?.isNativePlatform?.()) {
      const { installApkFromUrl } = await import("@/lib/printTransport");
      const r = await installApkFromUrl(safe);
      if (r?.ok) return;
      if (r?.error) throw new Error(r.error);
      const { Browser } = await import("@capacitor/browser");
      await Browser.open({ url: safe });
      return;
    }
  } catch (e) {
    if (e?.message && !/plugin assente/i.test(String(e.message))) throw e;
  }
  window.open(safe, "_blank", "noopener,noreferrer");
}
